import {Injectable} from '@angular/core';

import {AdjusterPresetsService} from '../adjuster-presets.service';
import {DatasetDescriptor} from './metadata-dialog.component';
import {RDFSubject} from '../ontology.model';

@Injectable({providedIn: 'root'})
export class MetadataDialogService {
  ontology: RDFSubject[];

  constructor(public adjusterPresetsService: AdjusterPresetsService) {
    this.ontology = this.adjusterPresetsService.ontology;
  }

  loadDatasetMetadata(datasetId: string): DatasetDescriptor {
    const ontoInfo = this.ontology.find(
      (subject) => subject['@id'] === datasetId
    );
    //TODO: the returned values must reflect possibility of multi-values (e.g. coverage CZ + EU)
    return {
      id: datasetId,
      title:
        this.adjusterPresetsService.getLabelInCurrentLang(
          ontoInfo['http://www.w3.org/2000/01/rdf-schema#label']
        ) ?? null,
      coverage:
        ontoInfo['http://www.semanticweb.org/attractiveness/hasCoverage']?.[0][
          '@id'
        ] ?? null,
      link:
        ontoInfo['http://www.semanticweb.org/attractiveness/link']?.[0][
          '@value'
        ] ?? null,
      lod:
        ontoInfo['http://www.semanticweb.org/attractiveness/hasLoD']?.[0][
          '@id'
        ] ?? null,
      source:
        ontoInfo['http://www.semanticweb.org/attractiveness/hasSource']?.[0][
          '@id'
        ] ?? null,
      update:
        ontoInfo['http://www.semanticweb.org/attractiveness/update']?.[0][
          '@value'
        ] ?? null,
    };
  }
}
